// extracted by mini-css-extract-plugin
module.exports = {"paginationContainer":"BlogPagination_paginationContainer__XteNP"};